<template>
    <div class="dashboard">
    <!--<div class="breadcrumbs">-->
    <!--<div class="breadcrumbs__title">-->
    <!--<span>Vous &ecirc;tes ici : </span>-->
    <!--</div>-->
    <!--<router-link to="/dashboard" class="breadcrumbs__item">Accueil</router-link> >-->
    <!--<div class="breadcrumbs__item">Tableau de bord</div>-->
    <!--</div>-->
    <div class="block__content--table ">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Tableau de bord</div>
          </div>
          <div class="form_ttl_first">Vos statistiques</div>
        </div>
      </div>
      <table>
        <thead>
        <tr>
          <th>Assistance</th>
          <th>Quantité</th>
          <th>Prix</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(garanty, index) in garanties">
          <td>{{ garanties[index].title }}</td>
          <td>{{ garanties[index].qty }}</td>
          <td>{{ garanties[index].price | formatEURWithoutSymbol | formatSeparateComma }} €</td>
        </tr>

        <tr>
          <td><b>Total</b></td>
          <td><b>{{totalGaranties}}</b></td>
          <td><b>{{totalPriceGaranties | formatEURWithoutSymbol | formatSeparateComma }} €</b></td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="block__content--chart">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="dougnhut-chart-wrapper">
            <div class="dougnhut-chart-wrapper__center-text">
              <p class="dougnhut-chart-wrapper__center-text--count">{{totalPriceGaranties | formatEURWithoutSymbol | formatSeparateComma}} €</p>
              <p class="dougnhut-chart-wrapper__center-text--title">Total</p>
            </div>
            <canvas id="account-quotes-doughnut-chart" width="300px" height="300px"></canvas>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="assets-list">
            <div class="assets-list__item" v-for="garanty in garanties">
              <div class="assets-list__item--percentage">{{garanty.qty}}</div>
              <div class="assets-list__item--title">{{garanty.title}}</div>
              <div class="assets-list__item--border"
                   v-bind:style="{ backgroundColor: garanty.color}"></div>
              <div class="assets-list__item--data">{{garanty.price | formatEURWithoutSymbol | formatSeparateComma}} €</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block__content--table ">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Assistances souscrites</div>
            <div class="page__head-title__text__small">
                            <span class="page__head-title__text__small--orange">
                                (7 derniers jours)
                            </span>
            </div>

          </div>
        </div>
      </div>

      <template v-if="isBusy">
        <Preloader/>
      </template>
      <template v-else>
        <table>
          <thead>
          <tr>
            <th>Date</th>
            <th>Etablissement Souscripteur</th>
            <th>Souscripteur</th>
            <th>Assistance souscrite</th>
            <th>Prix</th>
            <th>PDF</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="garanty in garantiesSouscrites">
            <td>{{parseDate(garanty)}}</td>
            <td>{{parseMechanicName(garanty)}}</td>
            <td>{{parseSouscripteurName(garanty)}}</td>
            <td>{{parseTypeGaranty(garanty)}}</td>
            <td>{{parsePrice(garanty) | formatSeparateComma}}</td>
            <td class="pdf-icon">
              <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_quittance(garanty.id)"/>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>
<script>
    import $ from 'jquery';
    import Chart from 'chart.js';
    import Preloader from '@/components/Preloader'
    import pdfPreviewMixin from '../mixins/pdfPreviewMixin';

    export default {
        name: 'RepresentativeGuemasPanel',
        components: {Preloader},
        mixins: [pdfPreviewMixin],
        data() {
            return {
                doughnutChart: null,
                isBusy: true,
                garantiesSouscrites: []
            }
        },
        computed: {
            mechanic_id() {
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
            representative_id() {
              return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
            },
            totalGaranties() {
                let totalBalance = 0;
                for (let i in this.garanties) {
                    totalBalance += +this.garanties[i].qty;
                }
                return totalBalance;
            },
            totalPriceGaranties() {
                let totalBalance = 0;
                for (let i in this.garanties) {
                    totalBalance += +this.garanties[i].price;
                }
                return totalBalance;
            },
            garanties() {
              //REPRESENTATIVE
              return [
                {
                  title: 'Assistance Autocars',
                  qty: this.getCountGaranties('autocarsQty'),
                  price: this.getPriceGaranties('autocarsPrice'),
                  color: '#008cc9'
                },
                {
                  title: 'Assistance Poids Lourds',
                  qty: this.getCountGaranties('poidslourdsQty'),
                  price: this.getPriceGaranties('poidslourdsPrice'),
                  color: '#ff0000'
                },
                {
                  title: 'Assistance Taxi - Ambulances - Corbillards - VSL',
                  qty: this.getCountGaranties('vslQty'),
                  price: this.getPriceGaranties('vslPrice'),
                  color: '#ffb510'
                },
                {
                  title: 'Assistance VU - VL',
                  qty: this.getCountGaranties('vulQty'),
                  price: this.getPriceGaranties('vulPrice'),
                  color: '#004767'
                },
                {
                  title: 'Assistance VUL 4097',
                  qty: this.getCountGaranties('vul4097Qty'),
                  price: this.getPriceGaranties('vul4097Price'),
                  color: '#f69638'
                },
              ];
            },
        },
        methods: {
            isDealer() {
              return this.$store.getters.isDealer;
            },
            isRepresentative() {
              return this.$store.getters.isRepresentative;
            },
            parseDate(garanty) {
                if (garanty && garanty.created_at) {
                    let day = garanty.datesParse.day_created,
                        month = garanty.datesParse.month_created,
                        year = garanty.datesParse.year_created;
                    return day + "/" + month + '/' + year;
                }

                return ' - ';
            },
            parsePrice(garanty) {
                return (garanty && garanty.assistance_price) ? this.roundEURWithoutSymbol(garanty.assistance_price) + ' €' : ' - '
            },
            parseMechanicName(garanty) {
                return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
            },
            parseSouscripteurName(garanty) {
                if (garanty && garanty.client && typeof garanty.client.name_of_signatory === 'string') {
                    const trimmed = garanty.client.name_of_signatory.trim();
                    if (trimmed) {
                        return trimmed;
                    }
                }
                return ' - ';
            },
            parseTypeGaranty(garanty) {
              if (garanty && garanty.type) {
                switch (+garanty.type) {
                  case 1: return 'Autocars 9509'; break;
                  case 2: return 'Poids Lourds 9510'; break;
                  case 3: return 'VSL 9511'; break;
                  case 4: return 'VU - VL 9512'; break;
                  case 5: return 'VP-VUL - 4097'; break;
                  default: return 'Autocars 9509'; break;
                }
              }

                return '';
            },
            parseTypeGarantyForDealers (guaranty) {
                if (this.isDealer()) {
                  return (guaranty.details.is_new.toLowerCase() === "oui") ? 'Garantie camping car neuf' : 'Garantie camping-car occasion';
                }
                return 'Camping car';
            },
            getGarantiesRepresentativeSouscrites() {
              if (this.representative_id) {
                let url = 'mutuaide/representative-search';
                let filterParams = {
                    start_date: this.moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    end_date: this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    pdf: 1,
                    sort: 'id|desc',
                  },
                  data = {
                    representative_id: this.representative_id,
                    ...filterParams,
                  };
                this.apiGet(url, data)
                  .then(response => {
                    this.isBusy = false;
                    this.garantiesSouscrites = response.data.data;
                  })
                  .catch(error => {
                    this.isBusy = false;
                  })
              }
            },
            getCountGaranties(type) {
                return this.$store.state.quotes && this.$store.state.quotes[type] ? +this.$store.state.quotes[type] : 0;
            },
            getPriceGaranties(type) {
                return this.$store.state.quotes && this.$store.state.quotes[type] ? this.roundEURWithoutSymbol(this.$store.state.quotes[type]) : 0;
            },
            drawAccountQuotesDoughnutChart() {
                let doughnutChartContainer = $('#account-quotes-doughnut-chart'),
                    data = [],
                    backgroundColor = [],
                    labels = [];
                for (let i in this.garanties) {

                    data.push(this.garanties[i].price);
                    backgroundColor.push(this.garanties[i].color);
                    labels.push(this.garanties[i].title);
                }
                if (this.doughnutChart) {
                    this.doughnutChart.destroy();
                }
                this.doughnutChart = new Chart(doughnutChartContainer, {
                    type: 'doughnut',
                    data: {
                        datasets: [{
                            data,
                            backgroundColor,
                            borderColor: 'transparent',
                        }],
                        labels
                    },
                    options: {
                        animation: false,
                        responsive: false,
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                                        currency = data.labels[tooltipItem.index];
                                    return currency + ': ' + this.replaceDotCommaAmount(value) + ' €';
                                }
                            },
                            backgroundColor: 'rgba(0,0,0,1)'
                        }
                    }
                });
            }
        },
        watch: {
            'garanties': function () {
                this.drawAccountQuotesDoughnutChart();
            },
            'representative_id': function () {
                this.getGarantiesRepresentativeSouscrites();
            }
        },
        mounted() {
            this.drawAccountQuotesDoughnutChart();
            this.getGarantiesRepresentativeSouscrites();
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/RepresentativeMutuaidePanel.vue